import React, { useState } from "react";
import {
  Link,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Box,
  DialogTitle,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";

import { Trans } from "react-i18next";

import { useTranslation } from "react-i18next";

export default function HelpDialog({
  open,
  onClose,
  showHelpDialogAtStartup,
  onShowHelpDialogAtStartupChange,
}) {
  const { t } = useTranslation();

  const handleShowAtStartupChange = (event) => {
    onShowHelpDialogAtStartupChange(event.target.checked);
  };

  const [scroll /*, setScroll*/] = useState("paper");

  // const descriptionElementRef = useRef(null);
  // useEffect(() => {
  //   if (open) {
  //     const { current: descriptionElement } = descriptionElementRef;
  //     if (descriptionElement !== null) {
  //       descriptionElement.focus();
  //     }
  //   }
  // }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        <Trans i18nKey="welcomeDialog.title">
          Bienvenido a la plataforma interactiva del{" "}
          <b>Programa de las Naciones Unidas para el Desarrollo</b> y{" "}
          <b>Grandata</b> para abordar las decisiones de política pública con
          soporte de datos.
        </Trans>
      </DialogTitle>
      <DialogContent dividers={scroll === "paper"}>
        {/* <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        > */}
        <Trans i18nKey="welcomeDialog.body">
          <Typography paragraph>
            Al navegar esta plataforma se puede:
          </Typography>
          <Typography paragraph component="ul">
            <li>
              Visualizar en el mapa los efectos de políticas públicas en
              Latinoamérica respecto del movimiento de los ciudadanos de cada
              país, y en más detalle al cliquear en cada provincia o estado.
              Cuanto más azul la superficie considerada, más se redujo la
              movilidad.
            </li>
            <li>
              Analizar en el gráfico la evolución de los casos de COVID-19 y
              relacionarlo con los efectos del aumento o la disminución de la
              movilidad de los ciudadanos en el tiempo.
            </li>
          </Typography>
          <Typography>
            Necesitamos tu ayuda para mejorar la plataforma. Por lo tanto, para
            visualizar la movilidad de los ciudadanos en más detalle, luego de
            clickear en el estado o provincia requerimos un login que nos
            permite comunicar los avances y que nos cuentes tu experiencia. Si
            deseas comunicarte con nosotros, escríbenos a 
            <Link href="mailto:info@grandata.com" color="info">
              info@grandata.com
            </Link>
            .
          </Typography>
        </Trans>

        {/* </DialogContentText> */}
      </DialogContent>
      <DialogActions>
        <Box flexGrow={1} pl={1} pr={1}>
          <FormControlLabel
            value="end"
            control={
              <Checkbox
                color="primary"
                checked={showHelpDialogAtStartup}
                onChange={handleShowAtStartupChange}
              />
            }
            label={t("welcomeDialog.doNotShowAgain")}
            labelPlacement="end"
          />
        </Box>
        <Button onClick={onClose} color="primary">
          {t("welcomeDialog.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
//   return (
//     <Modal open>
//       <Paper>
//         Grandata y el Programa de las Naciones Unidas para el Desarrollo han
//         lanzado una plataforma interactiva para abordar las decisiones de
//         política pública con soporte en datos. En el mapa se puede ver el
//         impacto de las políticas públicas en el movimiento de las poblaciones.
//         Cuanto más azul la superficie considerada, más se redujo la movilidad.
//         Se comienza con un mapa a nivel Latinoamericano y se puede entrar en
//         cada pais para ver provincia, estados e incluso municipios o colonias.
//       </Paper>
//     </Modal>
//   );
// }
